import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, AI_DETECTION_ENDPOINTS, CATEGORY } from '@core';
import { DetectionTaskStarted, DetectionTaskStatusResponse } from '@core/models/project.models';
import { ApiResponse } from '@core/models/api.models';

@Injectable()
export class FlooringApiService {
  private readonly api = inject(ApiService);

  triggerFlooringPreProcess(projectId: number): Observable<ApiResponse<DetectionTaskStarted>> {
    return this.api.post<DetectionTaskStarted>(AI_DETECTION_ENDPOINTS[CATEGORY.FLOORING.numericId].preProcess!, {
      project_id: projectId,
      file_type_id: CATEGORY.FLOORING.numericId,
    });
  }

  pollFlooringPreProcessStatus(taskId: string): Observable<DetectionTaskStatusResponse> {
    return this.api.get<DetectionTaskStatusResponse>(
      `${AI_DETECTION_ENDPOINTS[CATEGORY.FLOORING.numericId].taskStatus}/${taskId}`,
    ) as unknown as Observable<DetectionTaskStatusResponse>;
  }
}
